import {
    AfterViewChecked,
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    ViewChild,
} from '@angular/core'
import { AuthService } from '../../services/auth.services'
import * as moment from 'moment'
import * as $ from 'jquery'
import { AlignerHelper } from '../../../helper/aligner.helper'

@Component({
    selector: 'app-calendar-bar',
    templateUrl: './calendar-bar.component.html',
    styleUrls: ['./calendar-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarBarComponent implements OnInit, AfterViewInit, AfterViewChecked {
    @ViewChild('myeffect') element
    @Input() activeAligner: any
    @Input() type = 1 // 1-[Complaince effect]: active alginer (with 3 chart); 2-[Alginer-modal-progress]: choose aligner (with 1 chart); 3-[mobile]: active alginer (with 1 chart)
    @Input() autoStart = false
    @Input() xLabel = true
    @Input() mode = 'compact'
    @Input() classList = ''

    en = {}
    showEN = true
    showMessage = false
    startDate
    graphEndMonth
    calendar
    title = ''
    graphParams = []
    lastPassedAlignerCount = 0
    graphTypes = []
    options = {
        xLabel: true,
        autoStart: false,
    }
    phaseNumber = AlignerHelper.PHASE_NUMBERS
    phaseByName = AlignerHelper.PHASE_BY_NAMES

    constructor(private authData: AuthService,
                private cdRef: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.options = {
            xLabel: this.xLabel,
            autoStart: this.autoStart,
        }

        this.showMessage = !this.options.autoStart
        this.en = this.authData.showLang(this.showEN)
        if (this.activeAligner && this.activeAligner.aligners[0] && !this.isAborted(this.activeAligner.abortedFrom)) {
            this.title = this.activeAligner.title || ''
        } else {
            this.activeAligner = null
        }
    }

    ngAfterViewInit() {
        if (this.activeAligner) {
            this.initCalendar()
            if (this.options.autoStart) {
                setTimeout(() => {
                    this.graphParams.forEach((item, i) => {
                        this.startAnimation(i)
                    })
                }, 200)
            }
        }
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges()
    }

    initCalendar() {
        this.lastPassedAlignerCount = this.activeAligner.lastPassedAlignerCount
        const startTime = this.activeAligner.aligners[0].startDate
        this.startDate = moment(startTime)
        this.graphEndMonth = moment(this.activeAligner.endDate)
        let idealAccelerationTotal = 0
        let forecastTotal = 0
        const accelerationValue = this.activeAligner.aligners.length * 14
        let lastForcastDate = startTime
        let idealAccelerationValue = 0
        this.graphTypes[0] = []
        this.graphTypes[1] = []
        this.graphTypes[2] = []
        this.activeAligner.aligners.forEach((v, i) => {
            idealAccelerationValue = this.getDayInterval(v)
            const forecastValue = moment(v.startDate).diff(moment(lastForcastDate), 'days')

            this.graphTypes[0].push(idealAccelerationValue)
            if (i !== 0) {
                this.graphTypes[1].push(forecastValue)
            }
            this.graphTypes[2].push(14)

            lastForcastDate = v.startDate
            forecastTotal += forecastValue
            idealAccelerationTotal += idealAccelerationValue
        })
        forecastTotal += idealAccelerationValue
        this.graphTypes[1].push(idealAccelerationValue)
        let totalValue = 0
        this.classList = 'calendarbar-type-' + this.type
        if (this.type === 1) {
            const dateRang = Math.max(idealAccelerationTotal, forecastTotal, accelerationValue)
            this.calendar = this.getCalendar(this.startDate, moment(startTime).add(dateRang, 'days'), dateRang)

            const accelerationEndMonth = moment(startTime).add(accelerationValue, 'days').endOf('month')
            totalValue = dateRang

            this.graphParams = [
                {
                    caption: 'Ideal Acceleration',
                    series: [{
                        className: '',
                        endValue: idealAccelerationTotal,
                        iconName: 'fa fa-smile-o',
                        startValue: idealAccelerationTotal,
                        divs: this.graphTypes[0],
                    }],
                    totalValue: totalValue,
                },
                {
                    caption: 'Forecast',
                    series: [{
                        className: '',
                        endValue: forecastTotal,
                        iconName: 'fa fa-smile-o',
                        startValue: idealAccelerationTotal,
                        divs: this.graphTypes[1],
                    }],
                    totalValue: totalValue,
                },
                {
                    caption: 'No Acceleration',
                    series: [{
                        className: '',
                        endValue: accelerationValue,
                        iconName: 'fa fa-frown-o',
                        startValue: forecastTotal,
                        divs: this.graphTypes[2],
                    }],
                    totalValue: totalValue,
                },
            ]

        } else {
            const currentDay = moment().diff(startTime, 'day')
            const totalDay = moment(this.activeAligner.endDate).diff(startTime, 'day')
            const accelerationEndMonth = moment(this.activeAligner.endDate).endOf('month')
            totalValue = accelerationEndMonth.diff(startTime, 'day')
            let series
            // in feature
            if (currentDay < 0) {
                series = [
                    {
                        baseValue: 0,
                        className: 'sky',
                        endValue: totalDay,
                        startValue: 0,
                        divs: [],
                    }]
            } else if (totalDay > currentDay) {
                series = [
                    {
                        baseValue: null,
                        className: 'cold',
                        endValue: currentDay,
                        startValue: currentDay,
                        divs: [],
                    },
                    {
                        baseValue: currentDay,
                        className: 'sky',
                        endValue: totalDay - currentDay,
                        startValue: 0,
                        divs: [],
                    }]
            } else {
                series = [
                    {
                        baseValue: null,
                        className: 'cold',
                        endValue: totalDay,
                        startValue: totalDay,
                        divs: [],
                    }]
            }
            this.graphParams = [
                {
                    caption: this.getPhaseName(this.activeAligner.phase),
                    series: series,
                    totalValue: totalValue,
                },
            ]

            this.calendar = this.getCalendar(this.startDate, this.graphEndMonth, totalValue)

        }
    }

    getCalendar(startDate, endMonth, range) {
        const graphRange = range // endMonth.diff(startDate, 'day');
        const graphWidth = $('.acceleration-scale').width()
        const monthWidth = graphWidth / graphRange * 28

        let monthFormat
        let monthInterval
        if (monthWidth > 30) {
            monthFormat = 'MM'
            monthInterval = 1
        } else if (monthWidth > 15) {
            monthFormat = 'MM'
            monthInterval = 3
        } else {
            monthFormat = 'MM'
            monthInterval = 0
        }

        const calendar = []
        let lastYear = 0
        const cursor = moment(startDate)
        for (; cursor.isBefore(endMonth); cursor.startOf('month').add(1, 'month')) {
            const year = cursor.year()
            const month = (monthInterval && cursor.month() % monthInterval === 0) ? cursor.format(monthFormat) : null
            const days = moment(cursor).endOf('month').diff(cursor, 'days') + 1
            calendar.push({
                year: lastYear !== year ? year : null,
                month: days >= 20 ? month : null,
                days: days,
            })
            lastYear = year
        }

        return calendar
    }

    startAnimation(index, _options = null) {
        const that = this
        if (!this.graphParams) {
            return
        }

        this.showMessage = false
        const graphParam = this.graphParams[index]

        graphParam.series.forEach(function(element, elementIndex) {
            const accelerationBar = $('.acceleration-bar-table tbody tr').eq(index).find('.acceleration-bar').eq(elementIndex)
            const accelerationBarTextWrapper = accelerationBar.find('.acceleration-bar-text-wrapper')
            const accelerationBarText = accelerationBar.find('.acceleration-bar-text')
            const accelerationBarDiv = accelerationBar.find('.acceleration-bar-div')

            const startWidth = Math.round(element.startValue / graphParam.totalValue * 100)
            const endWidth = Math.round(element.endValue / graphParam.totalValue * 100)
            const baseLeft = Math.round((element.baseValue || 0) / graphParam.totalValue * 100)

            const options = Object.assign({
                enterFade: 0.5,
                enterLength: (endWidth - startWidth) / 100 * 2,
                enterText: 0.2,
            }, _options)

            accelerationBarDiv.css('font-size', '100%')
            accelerationBarDiv.find('span').fadeOut()

            if (!accelerationBar.data('animation-done')) {
                // show graph
                accelerationBar
                .css('transition', 'none')
                .css('width', startWidth + '%')
                .css('opacity', 0)
                .css('left', baseLeft + '%')
                .data('animation-done', true)
                .show()
                accelerationBarTextWrapper
                .css('right', '-' + accelerationBarTextWrapper.width() + 'px')
                .css('transition', 'none')
                .css('opacity', 0)
                .attr('title', element.endValue + ' days')

                accelerationBarText
                .text(element.endValue)

                const transitionTime = options.enterFade + options.enterLength
                // speedup
                const transitionTimeout = (transitionTime + 0.5) * 1000 - accelerationBarDiv.length * 4
                console.debug(transitionTime, transitionTimeout)
                setTimeout(function() {
                    accelerationBar
                    .css('transition', options.enterFade + 's ease-out opacity, ' + options.enterLength + 's linear width ' + options.enterFade + 's')
                    accelerationBarTextWrapper
                    .css('transition', options.enterText + 's ease-out opacity ' + transitionTime + 's')
                }, 10)
                //
                setTimeout(function() {
                    accelerationBar.css('width', endWidth + '%')
                    accelerationBar.css('opacity', 1)
                    accelerationBarTextWrapper.css('opacity', 1)
                }, 20)

                setTimeout(() => {
                    $.each(accelerationBarDiv, function(i: any) {
                        const $that = $(this)
                        if ($that.width() < 20) {
                            $that.css('font-size', '50%')
                        } else if ($that.width() < 30) {
                            $that.css('font-size', '65%')
                        }
                        $(this).children().fadeIn(300 + (i * 10))

                    })
                }, transitionTimeout)
            } else {
                // hide graph
                accelerationBar
                .css('transition', '0.5s ease-out all')
                .data('animation-done', false)
                setTimeout(function() {
                    accelerationBar.css('opacity', 0)
                }, 100)
            }
        })
    }

    private getPhaseName(pharse) {
        let title = ''
        if (this.phaseByName[pharse]) {
            title = this.phaseByName[pharse].name
        } else if (this.phaseNumber[pharse]) {
            title = this.phaseNumber[pharse - 1].name
        } else {
            title = pharse || ''
        }
        title += ' ' + this.title
        return title
    }

    private getDayInterval(stage) {
        let result = 0
        if (stage) {
            if (stage.intervalUnit === 'months') {
                const endDateInterval = moment(stage.startDate).add(stage.interval, 'months')
                result = endDateInterval.diff(stage.startDate, 'days')
            } else {
                result = parseInt(stage.interval, 10)
            }
        }

        return result
    }

    private isAborted(abortedFrom) {
        return abortedFrom !== null && abortedFrom !== undefined && abortedFrom !== ''
    }

    trackByDiv = (item) => {
        return item
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/calendar-bar/calendar-bar.component.ts